import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import gtm from 'general/js/gtm';
import { getDefaultFilters, isFiltersDirty } from '../../listing/js/listing-helper';
import Listing from '../../listing/js/Listing';
import ListingLoadMore from '../../listing/js/ListingLoadMore';
import NewsFeedHeader from './news-feed-header';
import NewsFeedListing from './news-feed-listing';
import BannerCard from 'components/cards/js/banner-card';

class NewsFeedLayout extends React.Component {
    constructor(props) {
        super(props);

        this.defaultFilters = {
            ...getDefaultFilters(props.options.filters)
        };
    }

    renderGroupsListing(items) {
        const groupsList = [];
        const totalGroups = Math.ceil(items.length / this.props.patternSize);

        for (let i = 0; i < totalGroups; i++) {
            const startIndex = i * this.props.patternSize;
            const endIndex = (i + 1) * this.props.patternSize;
            const groupItems = items.slice(startIndex, endIndex);

            groupsList.push(
                <React.Fragment key={i}>
                    <NewsFeedListing
                        items={groupItems}
                        pattern={this.props.pattern}
                        banner={this.props.banner}
                    />
                    {
                        groupItems.length === this.props.patternSize &&
                        this.renderBanner()
                    }
                </React.Fragment>
            );
        }

        return groupsList;
    }

    renderBanner() {
        if (!this.props.banner) return null;

        return (
            <div className="news-feed-row">
                <BannerCard model={this.props.banner}/>
            </div>
        );
    }

    renderNoResults() {
        return (
            <div className="news-feed__no-results">
                <div>
                    <p>No results.</p>
                    <p>Please try making your search a little wider</p>
                </div>
            </div>
        );
    }

    onLoadMoreClick = (onLoadMoreFromProps) => {
        gtm.push('Load More', 'Click', window.location.href);
        onLoadMoreFromProps();
    }

    render() {
        return (
            <Listing
                options={this.props.options}
                defaultFilters={this.defaultFilters}
                render={({
                             items,
                             filters,
                             pagination,
                             isLoadingMore,
                             onLoadMore,
                             onFiltersChange
                         }) => (
                    <React.Fragment>
                        {
                            this.props.onFiltersDirtyChange(isFiltersDirty(filters, this.props.options.filters))
                        }
                        {
                            ReactDOM.createPortal(
                                <NewsFeedHeader
                                    filters={filters}
                                    filtersNode={this.props.filtersNode}
                                    options={this.props.options}
                                    translations={this.props.translations}
                                    onFiltersChange={onFiltersChange}
                                />,
                                this.props.filtersNode
                            )
                        }
                        <div className="news-feed-listing" data-content aria-live="polite">
                            {this.renderGroupsListing(items)}
                            {!items.length && this.renderNoResults()}
                        </div>
                        <ListingLoadMore
                            onLoadMore={() => this.onLoadMoreClick(onLoadMore)}
                            pagination={pagination}
                            isLoadingMore={isLoadingMore}/>
                    </React.Fragment>
                )}/>
        );
    }
}

NewsFeedLayout.propTypes = {
    options: PropTypes.object.isRequired,
    pattern: PropTypes.array.isRequired,
    translations: PropTypes.object,
    banner: PropTypes.object,
    patternSize: PropTypes.number,
    filtersNode: PropTypes.instanceOf(Element).isRequired,
    onFiltersDirtyChange: PropTypes.func.isRequired,
};

export default NewsFeedLayout;
